import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { Grid, Form, Select } from 'semantic-ui-react';
import { InputField } from 'Common/SemanticWrapper';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';

import { GENERIC_EXPORT_SETUP_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { GenericExportSetupFieldEnum as Fields } from 'Common/FieldEnum';
import { makeOptionsData } from 'Common/FormHelper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { MappingModalField } from 'Common/ReduxFormFields/MappingModalField';

class GenericExportSetupForm extends Component {
  static propTypes = {
    exportFileTypes: PropTypes.array.isRequired,
    selectedFileType: PropTypes.number,
    gridData: PropTypes.array,
    setExportFileTypeFuture: PropTypes.func.isRequired,
    showDirtyConfirm: PropTypes.func.isRequired,
  };

  static defaultProps = {
    gridData: [],
  };

  onFileTypeChange = (e, data) => {
    e.preventDefault();

    this.props.setExportFileTypeFuture(data.value);
    this.props.showDirtyConfirm();
  };

  state = {
    mappingModalProps: null,
  };

  onMappingMenuClick = row => {
    this.setState({
      mappingModalProps: {
        name: Fields.ExportMappingList,
        title: row.Description,
        textBoxMapping: true,
        doneCallback: () => {
          this.setState({ mappingModalProps: null });
        },
        mappingOptions: [],
      },
    });
  };

  columns = [
    {
      Header: 'Field Description',
      accessor: Fields.Description,
      minWidth: 75,
      filterable: false,
    },
    {
      Header: 'Constant Value',
      id: Fields.ConstantValue,
      minWidth: 75,
      filterable: false,
      Cell: row => {
        const { Mapped } = row.original;

        if (Mapped) return null;

        return (
          <Field
            label={false}
            component={InputField}
            name={`${Fields.ConstantValues}[${row.index}].${
              Fields.ConstantValue
            }`}
            maxLength={50}
            hideError={true}
          />
        );
      },
    },
    {
      width: 40,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps =>
        GridContextMenu({ gridProps, options: this.menuOptions }),
    },
  ];

  menuOptions = [
    {
      icon: 'sitemap',
      text: 'Mapping',
      handler: this.onMappingMenuClick,
      disabledWhen: x => !x.Mapped,
    },
  ];

  renderGrid() {
    const {
      initialValues: { ExportFileType },
      gridData,
      loading,
    } = this.props;

    if (ExportFileType === undefined) {
      return null;
    }

    return (
      <ReactTable
        columns={this.columns}
        data={gridData}
        loading={loading}
        minRows={1}
        showPagination={false}
      />
    );
  }

  render() {
    const { handleSubmit, exportFileTypes, selectedFileType } = this.props;
    const { mappingModalProps } = this.state;

    return (
      <div>
        <Form onSubmit={handleSubmit}>
          <TitledCard title={'Select a File Type'}>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Select
                    fluid
                    options={makeOptionsData(exportFileTypes)}
                    onChange={this.onFileTypeChange}
                    value={selectedFileType}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={1}>
                <Grid.Column>{this.renderGrid()}</Grid.Column>
              </Grid.Row>
            </Grid>
          </TitledCard>
          {mappingModalProps && (
            <Field component={MappingModalField} {...mappingModalProps} />
          )}
        </Form>
      </div>
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  return errors;
};

export default reduxForm({
  validate,
  form: GENERIC_EXPORT_SETUP_FORM_NAME,
  enableReinitialize: true,
})(GenericExportSetupForm);



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/components/GenericExportSetupForm.js